module.exports = __webpack_public_path__ + "img/huggingface-logo.a2fc8a21.svg";